// services
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useProjectSGService = () => {
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    const getAllProjectsSG = async (organizationId = 0): Promise<any[]> => {
        const res = await axios.get(
            `${apiUrl}/projectsg/org/${organizationId}/0`,
        );
        return res.data || [];
    };

    const getAllProjectsSGListByOrg = async (
        organizationId = 0,
    ): Promise<any[]> => {
        const res = await axios.get(
            `${apiUrl}/projectsg/org/${organizationId}`,
        );
        return res.data || [];
    };

    const getHubModulesProjectSummary = async (
        currentCourseId: any,
    ): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/projectsg/hub-module/all-summary/${
                currentCourseId || 0
            }`,
        );
        return res.data || [];
    };

    const getAllProjectSGDefaultSummary = async (): Promise<any> => {
        const res = await axios.get(`${apiUrl}/projectsg/default/all-summary`);
        return res.data || [];
    };

    const getAllProjectSGCustomForLinking = async (
        orgId: number = 0,
    ): Promise<any> => {
        const res = await axios.get(`${apiUrl}/projectsg/custom/link/${orgId}`);
        return res.data || [];
    };

    const getAllProjectSGCustom = async (): Promise<any> => {
        const res = await axios.get(`${apiUrl}/projectsg/custom/all`);
        return res.data || [];
    };

    const getAllProjectSGPartnerSummary = async (): Promise<any> => {
        const res = await axios.get(`${apiUrl}/projectsg/partner/all-summary`);
        return res.data || [];
    };

    const getAllProjectsSGByOrg = async (
        org_id,
        course_schema_id,
    ): Promise<any[]> => {
        const res = await axios.get(
            `${apiUrl}/projectsg/org/${org_id}/${course_schema_id}`,
        );
        return res.data || [];
    };

    const getProjectSG = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/projectsg/${id}`);
        return res.data;
    };

    const getProjectSGByGeoRecId = async (
        geoRecordId: number,
    ): Promise<number> => {
        const res = await axios.get(
            `${apiUrl}/projectsg/geo-record/${geoRecordId}`,
        );
        return res.data;
    };

    const getProjectSGSummaryById = async (id: number): Promise<any> => {
        const res = await axios.get(`${apiUrl}/projectsg/summary/${id}`);
        return res.data;
    };

    const deleteProjectSG = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/projectsg/${id}`);
        return res.data;
    };

    const createProjectSG = async (projects: any): Promise<any> => {
        const res = await axios.post(`${apiUrl}/projectsg`, projects);
        return res.data;
    };

    const createMultipleProjectSGViaDuplicate = async (
        payload: any,
    ): Promise<any> => {
        const res = await axios.post(`${apiUrl}/projectsgs`, payload);
        return res.data;
    };

    const removeMultipleProjectSGViaDuplicate = async (
        payload: any,
    ): Promise<any> => {
        const res = await axios.deleteObject(`${apiUrl}/projectsgs`, payload);
        return res.data;
    };

    const updateProjectSG = async (projects: any): Promise<any[]> => {
        const res = await axios.put(`${apiUrl}/projectsg`, projects);
        return res.data;
    };

    const updateProjectSGGeoRecs = async (
        updateData: any,
        orgId: number,
    ): Promise<boolean> => {
        const res = await axios.put(
            `${apiUrl}/projectsg/geo-record-categories/${orgId}`,
            updateData,
        );
        if (res.status == 200 || res.status == 201) {
            return true;
        } else {
            return false;
        }
    };

    const getProjectSGGeoRecCategoriesAsTree = async (
        projId: number,
    ): Promise<any> => {
        const res = await axios.get(`${apiUrl}/projectsg/grc/tree/${projId}`);
        return res.data;
    };

    const getSustainableModuleMeta = () => {
        return {
            id: 2,
            name: 'Sustainable Golf',
            organizationId: 1,
            geoRecordCategoryIds: [12255],
            geoRecordCount: 0,
            color: '#009C64',
            showInBar: true,
        };
    };

    return {
        getAllProjectsSG,
        getProjectSGSummaryById,
        getHubModulesProjectSummary, //returns course-manager, and public geo rec category/geo-rec info for that org
        getAllProjectSGDefaultSummary, //returns default modules copied to that org
        getAllProjectSGPartnerSummary, //returns partner modules copied to that org
        getAllProjectSGCustomForLinking, //returns summary of custom modules that org has created
        getAllProjectSGCustom, //returns custom projects that org has created
        getAllProjectsSGByOrg,
        getAllProjectsSGListByOrg,
        getProjectSG,
        getProjectSGByGeoRecId,
        deleteProjectSG,
        createProjectSG,
        createMultipleProjectSGViaDuplicate,
        removeMultipleProjectSGViaDuplicate,
        updateProjectSG,
        updateProjectSGGeoRecs,
        getProjectSGGeoRecCategoriesAsTree,
        getSustainableModuleMeta,
    };
};
